import Vehicle from '@/components/features/vehicle/Vehicle';
import { createFileRoute } from '@tanstack/react-router';
import i18next from 'i18next';
import { z } from 'zod';

const vehicleSearchSchema = z.object({
  project_id: z.string().optional(),
  environment_id: z.string().optional(),
});

const VehicleDetailPage = () => {
  const { vehicle_id } = Route.useParams();
  const { project_id, environment_id } = Route.useSearch();

  return (
    <Vehicle
      projectId={project_id}
      environmentId={environment_id}
      vehicleId={vehicle_id}
    />
  );
};

export const Route = createFileRoute('/vehicles/$vehicle_id')({
  validateSearch: (search) => vehicleSearchSchema.parse(search),
  head: () => ({
    meta: [
      {
        title: `${i18next.t('vehicle.title')} | Vehicle Console`,
      },
    ],
  }),
  component: VehicleDetailPage,
});
